import { getTariffs, addTariffs, removeTariffs } from '../../integration/tariff.api';
import structureData from '../../../util/Format.util';
import getCarts from '../../integration/cart.api';
import { viewItemListAnalytics } from '../../../util/gtm';
import useLocalStorage, { setCode } from '../../hooks/useLocalStorage';
import { getCookie, getTokenFromCookies } from '../../hooks/useCookie';

const localStore = useLocalStorage();

// eslint-disable-next-line no-unused-vars
export const getTvTariffs = async ({
  graphql,
  contractDuration,
  // isCO = false,
  isCS = false,
  cartData,
}) => {
  // get tv tariffs
  try {
    let offerData = [];
    // eslint-disable-next-line no-nested-ternary
    const acquisitionType = getCookie('cart_Type')
      ? getCookie('cart_Type') === 'CHANGE_OFFER' || getCookie('cart_Type') === 'NEW_ACQUISITION'
        ? getCookie('cart_Type')
        : 'CROSS_SELL'
      : 'NEW_ACQUISITION';

    let coVars = {};
    if (getCookie('cart_type') === 'CHANGE_OFFER' && !isCS) {
      // const { getCart: cartData } = await getCarts({
      //   graphql,
      //   variables: {
      //     reference: getCookie('reference'),
      //     cartType: 'CHANGE_OFFER',
      //     token: getTokenFromCookies(),
      //   },
      // });

      coVars = {
        cartType: 'CHANGE_OFFER',
        reference: getCookie('reference'),
        parentOfferCode:
          cartData?.offers?.find(offer => offer.baseOffer?.serviceGroup === 'DUALPLAY')?.baseOffer
            ?.catalogCode || getCookie('CATALOG_CODE'),
        token: getTokenFromCookies(),
      };
    }
    offerData = await getTariffs({
      graphql,
      variables: {
        serviceGroupCode: 'TV',
        acquisitionType: !isCS ? acquisitionType : 'CROSS_SELL',
        ...coVars,
      },
      staticBB: true,
    });
    // }

    const filteredResult = offerData?.tariffs?.filter(
      res => res.commitmentDuration === contractDuration
    );
    const result = filteredResult?.map(offer => structureData(offer, graphql));
    if (result) viewItemListAnalytics('TV_Tariffs', result);
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const addTvTariffs = async (graphql, code, offerCode, cart, cartType = '', isCO = false) => {
  // add tv tariffs
  let prospectReference = '';
  if (isCO) setCode('CO');
  if (localStore.getLocalStorage('PROSPECTUUID')) {
    prospectReference = localStore.getLocalStorage('PROSPECTUUID');
  }
  let variables = {
    reference: !isCO ? prospectReference : localStore.getLocalStorage('ref'),
    catalogOfferCode: offerCode,
    catalogTariffPlanCode: code,
    serviceGroup: 'TV',
    parentOfferId: JSON.stringify(
      cart?.offers?.find(offer => offer.baseOffer?.serviceGroup === 'DUALPLAY')?.id
    ),
  };
  // if a TV offer is already in cart
  if (cart?.offers.length > 0) {
    const offerId = cart?.offers?.filter(offer => offer.baseOffer?.serviceGroup === 'TV')[0]?.id;
    variables = {
      ...variables,
      offerId,
    };
  }

  // If prospect is not available in localstorage
  if (!localStore.hasValue('prospectUuid')) {
    variables = {
      ...variables,
      prospectUuid: '',
      offerType: 'POSTPAY',
    };
  }
  if (cartType === 'CROSS_SELL') {
    // let prequalId = '';
    setCode('CO');
    // if (localStore.getLocalStorage('PREQUALID')) {
    //   prequalId = JSON.parse(localStore.getLocalStorage('PREQUALID'));
    // }
    // const parentOfferId = `${JSON.parse(getCookie('subscription')).id}`;
    const parentSubscriptionId = parseInt(getCookie('subscription_id'), 10);
    const reference = getCookie('reference');
    variables = {
      reference,
      catalogOfferCode: offerCode,
      catalogTariffPlanCode: code,
      // prequalId: parseInt(prequalId, 10),
      serviceGroup: 'TV',
      // parentOfferId,
      parentSubscriptionId,
      cartType,
    };
    try {
      const data = await addTariffs({
        graphql,
        variables,
      });
      return data.addTariff;
    } catch (error) {
      return { error };
    }
  }
  if (cartType === 'CHANGE_OFFER' || isCO) {
    // let prequalId = '';
    // setCode('CO');
    // if (localStore.getLocalStorage('PREQUALID')) {
    //   prequalId = JSON.parse(localStore.getLocalStorage('PREQUALID'));
    // }
    // const parentOfferId = `${JSON.parse(getCookie('subscription')).id}`;
    // const parentSubscriptionId = JSON.parse(getCookie('subscription')).id;
    const reference = getCookie('reference');
    variables = {
      reference,
      catalogOfferCode: offerCode,
      catalogTariffPlanCode: code,
      // prequalId: parseInt(prequalId, 10),
      // parentSubscriptionId: parseInt(
      //   JSON.stringify(
      //     cart?.offers?.find(offer => offer.baseOffer?.serviceGroup === 'DUALPLAY')?.id
      //   ),
      //   10
      // ),
      serviceGroup: 'TV',
      parentOfferId: JSON.stringify(
        cart?.offers?.find(offer => offer.baseOffer?.serviceGroup === 'DUALPLAY')?.id
      ),
      // cartType: 'CHANGE_OFFER',
    };
    try {
      const data = await addTariffs({
        graphql,
        variables,
      });
      return data.addTariff;
    } catch (error) {
      return { error };
    }
  }
  try {
    const data = await addTariffs({
      graphql,
      variables,
    });
    return data.addTariff;
  } catch (error) {
    return { error };
  }
};

const getSelectedTvOfferFromCart = async ({ graphql, localStorage }) => {
  // get the selected offer value from prospect.
  const { getCart: cartData } = await getCarts({
    graphql,
    variables: { reference: localStorage.getLocalStorage('PROSPECTUUID') },
  });

  return {
    cartData,
    selectedOffer: cartData?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'TV'),
  };
};

// on Tv page load
export const onload = async ({ graphql, localStorage }) => {
  let result = {};
  let selectedTvOffer = {};
  try {
    // if prospect is already present
    if (localStorage.hasValue('PROSPECTUUID')) {
      // getting selected mobile offers from cart
      const { selectedOffer, cartData } = await getSelectedTvOfferFromCart({
        graphql,
        localStorage,
      });
      // get all offers
      const contractDuration = {
        12: 12,
        24: 24,
        TWELVE: 12,
        TWENTY_FOUR: 24,
      }[selectedOffer[0]?.baseOffer?.commitmentDuration];
      const offerData = await getTvTariffs({
        graphql,
        contractDuration,
      });
      result = {
        offers: offerData,
        cartData,
      };

      // if TV tariff available in prospect
      if (selectedOffer.length > 0) {
        // formatting select offer
        selectedTvOffer = offerData.filter(
          offer => selectedOffer[0]?.baseOffer?.catalogTariffPlanCode === offer.code
        )[0].code;
        result = {
          ...result,
          selectedTvOffer,
          cartData,
        };
      }
    } else {
      const offerData = await getTariffs({
        graphql,
        variables: { serviceGroupCode: 'TV' },
        acquisitionType: 'NEW_ACQUISITION',
        staticBB: true,
      });

      result = {
        offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
        devices: undefined,
        selectedBroadbandOffer: false,
      };
    }
  } catch (error) {
    console.error('something went wrong on load of /shop/broadband', error);
  }
  return result;
};

export const removeTvTariffs = async (graphql, offerid, cartType = '', isCO = false) => {
  let prospectReference = '';
  if (isCO) setCode('CO');
  if (localStore.getLocalStorage('PROSPECTUUID')) {
    prospectReference = localStore.getLocalStorage('PROSPECTUUID');
  }
  if (cartType === 'CROSS_SELL') {
    setCode('CS');
    const token = getTokenFromCookies();
    try {
      const data = await removeTariffs({
        graphql,
        variables: {
          reference: localStore.getLocalStorage('ref') || getCookie('reference'),
          offerId: offerid,
          cartType,
          token,
        },
      });
      return data.removeTariff;
    } catch (error) {
      return { error };
    }
  }
  if (cartType === 'CHANGE_OFFER' || isCO) {
    setCode('CO');
    const reference = getCookie('reference');
    const variables = {
      reference,
      serviceGroup: 'TV',
      cartType: 'CHANGE_OFFER',
      offerId: offerid,
      token: getTokenFromCookies(),
    };
    try {
      const data = await removeTariffs({
        graphql,
        variables,
      });
      return data.removeTariff;
    } catch (error) {
      return { error };
    }
  }
  try {
    const data = await removeTariffs({
      graphql,
      variables: {
        reference: prospectReference,
        offerId: offerid,
      },
    });
    return data.removeTariff;
  } catch (error) {
    return { error };
  }
};
